import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiHost } from '../../../../app/infrastructure/http/apiClient';
import {
  unwrapNotificationsCount,
} from '../../application/mapNotifications';
import type {
  NotificationItem,
  NotificationsCount,
} from '../../application/types';

function authorizationHeader(token?: string | null): string | undefined {
  if (!token) {
    return undefined;
  }
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

function apiBaseUrl(): string {
  const host = getApiHost();
  return host.endsWith('/') ? host : `${host}/`;
}

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl(),
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const token = (
        getState() as { authorization?: { accessToken?: string | null } }
      ).authorization?.accessToken;
      const value = authorizationHeader(token);
      if (value) {
        headers.set('Authorization', value);
      }
      return headers;
    },
  }),
  tagTypes: ['NotificationsCount', 'NotificationsList'],
  endpoints: (build) => ({
    getNotificationsCount: build.query<NotificationsCount, void>({
      query: () => ({
        url: 'notifications/count',
        method: 'GET',
      }),
      transformResponse: unwrapNotificationsCount,
      providesTags: ['NotificationsCount'],
    }),
    /** List not on /v1 yet — empty until backend adds GET /notifications. */
    getNotificationsList: build.query<NotificationItem[], void>({
      queryFn: async () => ({ data: [] as NotificationItem[] }),
      providesTags: ['NotificationsList'],
    }),
  }),
});

export const {
  useGetNotificationsCountQuery,
  useGetNotificationsListQuery,
} = notificationsApi;
